module.exports = __webpack_public_path__ + "static/media/new-poll-icon.faa89dde.svg";